import React from "react";
import { IMG } from "../../../asset";

export default function Team() {
  const array = [
    {
      id: 1,
      img: IMG.us1,
      name: "Rocky  Robbins",
      desp: "Operations Mgmt / Bus Dev",
      desp2: "MBA, BS Petroleum Engineering",
      // desp2: "Business Development",
      // desp3: "MBA, B.S Petroleum Engineering",
    },
    {
      id: 2,
      img: IMG.us2,
      name: "Sam Pannunzio",
      desp: "Operations / Strategy Mgmt,",
      desp2: "MBA BS Chemical Engineering",
      desp3: "",
    },
    {
      id: 3,
      img: IMG.us3,
      name: "Ekaterina Robbins",
      desp: "BS Education, GIA Appraiser",
      desp2: "",
      desp3: "",
    },
    {
      id: 4,
      img: IMG.us4,
      name: "Sam Boyar",
      desp: "Finance / Oil & Gas / Asset Mgmt. ",
      desp2: "MBA BS Geological Sciences",
      desp3: "",
    },
  ];
  return (
    <div className="h-auto w-full flex justify-center items-center md:mb-0">
      <div className="text-center lg:text-start w-full h-full">
        <div className="w-full border-t-2 border-dark flex justify-center mb-[4px] md:mb-[1px] lg:mb-[4px] mt-[10px] md:mt-0">
          <p className="text-white bg-dark font-black w-[200px] text-[17px] md:text-[12px] xl:text-[17px] text-center 2xl:text-[2vh] 2xl:w-[10vh]">
            TEI GP
          </p>
        </div>
        <div className="grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-4 px-[55px] w-full gap-5 py-2">
          {array.map((data) => (
            <div
              className=" w-full mt-4 md:mt-0 flex justify-center"
              key={data.id}
            >
              <div className="w-full flex items-center  flex-col lg:flex-row lg:items-start">
                <img
                  src={data.img}
                  alt="user"
                  className="border-gray border-[1px] w-[100px] h-[100px] md:w-[50px] md:h-[50px] lg:w-[70px] lg:h-[70px] 2xl:h-[11vh] 2xl:w-[11vh] rounded-full "
                />
                <div className=" w-full h-full flex flex-col justify-center pl-2">
                  <p className="text-dark font-black text-[17px] md:text-[15px] xl:text-[17px] 2xl:text-[2vh]">
                    {data.name}
                  </p>
                  <p className="w-full text-dark text-[13px] md:text-[9px] lg:text-[10px] xl:text-[13px] font-semibold">
                    {data.desp}
                  </p>
                  <p className="w-full text-dark text-[13px] md:text-[9px] lg:text-[10px] xl:text-[13px] font-semibold">
                    {data.desp2}
                  </p>
                  <p className="w-full text-dark text-[13px] md:text-[9px] lg:text-[10px] xl:text-[13px] font-semibold">
                    {data.desp3}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
